import React, {forwardRef, useMemo, useRef} from 'react';
import useIsOverflowing from "./useIsOverFlowing";
import withHover from "./higherOrderComponents/withHover";
import withTooltip from "./higherOrderComponents/withTooltip";
import Tooltip from "./Tooltip";
const ChPercentageBar = (props) => {

    const {values = [20,30,10,35,5],
        colors= ['red','green','blue','violet','orange'],
        tags = ['','','','','']
    } = props;

    //calculate total;
    let total = 0;
    values.forEach((val)=>{
        total += val;
    });

    //calculate percentage;
    values.forEach((val, index, array)=>{
        if(val !== 0){
            array[index] = Math.round(val/total*100);
        }

    });

    const PercentBar = (props)=>{
        const {val, index, tag}  = props;
        const ref = useRef(null),
            isOverflowing = useIsOverflowing(ref);

        return <Tooltip placement={'top'} title={val+'% '+tag}><div ref={ref} role="listitem" aria-label={val+'% '+tag} style={{color: isOverflowing ? colors[index] : 'white', backgroundColor:colors[index], width:val+'%'}}>{val}%</div></Tooltip>;

    }

    return(
        <div role="list" className={'flexWrap ch-percentage-bar-graph flexCentre'} style={{width:'100%',color:'#FEFEFE'}}>
            {values.map((val,index)=>{
                if(val !== 0){
                    return <PercentBar key={index} val={val} tag={tags[index]} index={index}/>
                }
            })}
        </div>
    )

}

export default ChPercentageBar;